// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2KMyu","vLegacy":"SelectSecondary_vLegacy__2vbEc","error":"SelectSecondary_error__cv8K-","disabled":"SelectSecondary_disabled__1NnpE"};